import { Banner, BlueCard, BlueLarge, CS_BG } from "../images/index";
import {
  NYC,
  Wholesale,
  Insurance,
  RetailGrocery,
  GoveernMentPublicSector,
  HealthCareLifeSciences,
  LogisticsSupplyChain,
  image333,
  Image391,
} from "../images/CaseStudies";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import ScrollToTopButton from "../components/ScrollToTopButton";
import {
  GSActive,
  GSInactive,
  HSActive,
  HSInactive,
  LSactive,
  LSInactive,
  RGActive,
  RGInActive,
} from "../images/Industries";
import useSlug from "./SlugComp";
import SEO from "./Seo";
import { getPagesBySlug, getCaseStudies } from "../services/apiService";
import CaseStudy from "./parser";
const CLIENTS_BASE_URL = "http://localhost:5000";

const caseStudies = [
  {
    title: "Educational Client – CyberSecurity Modernization",
    bullets: [
      "A dedicated 24-member team delivered the project successfully — on time and within the planned two-year schedule",
      "Security aligned with NIST and CIS standards",
      "Reduced incident response time by 40%",
    ],
    cta: "Read Full Story",
    img: Image391,
    imgAlt: "NYC Department of Education",
  },
  {
    title: "Wholesale Grocery Leader – AI Forecasting",
    bullets: [
      "Reduced spoilage losses by 17%",
      "Improved inventory turnover by 23%",
      "Deployed across 12 distribution centers",
    ],
    cta: "Read Full Story",
    img: Wholesale,
    imgAlt: "Grocery Market",
  },
  {
    title: "Insurance Client – Claims Automation",
    bullets: [
      "Automated 85% of claims workload using AI + RPA",
      "Reduced SLA breaches by 40%",
      "Improved customer satisfaction",
    ],
    cta: "Read Full Story",
    img: Insurance,
    imgAlt: "Life Insurance",
  },
];

function CaseStudies() {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/contact");
  };
  const [activeTab, setActiveTab] = useState("retail");
  const [metaData, setMetaData] = useState({});
  const [caseStudiesData, setCaseStudiesData] = useState([]);
  const slug = useSlug();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const slugData = await getPagesBySlug(slug.toLowerCase());
        setMetaData(slugData.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    const fetchCaseStudies = async () => {
      try {
        const caseStudiesResponse = await getCaseStudies();
        setCaseStudiesData(caseStudiesResponse.data);
      } catch (error) {
        console.error("Error fetching case studies:", error);
      }
    };

    fetchCaseStudies();
    fetchJobs();
  }, []);

  const tabs = [
    {
      key: "retail",
      label: "Retail & Grocery",
      activeIcon: RGActive,
      inActiveIcon: RGInActive,
      points: [
        "AI-driven demand forecasting to cut waste and optimize inventory",
        "Dynamic pricing and promotions for smarter sales strategies",
        "Personalized shopping experiences with recommendation engines",
        "Computer vision for shelf monitoring and shrinkage detection",
        "RPA automation for invoices, claims, and back-office tasks",
      ],
      image: RetailGrocery,
    },
    {
      key: "government",
      label: "Government & Public Sector",
      activeIcon: GSActive,
      inActiveIcon: GSInactive,
      points: [
        "Security modernization & cloud migration for agencies",
        "Governance, risk, and compliance programs (NIST, CIS, HIPAA)",
        "Third-party risk management & SOC operations",
        "Digital workflows for smarter citizen services",
      ],
      image: GoveernMentPublicSector,
    },
    {
      key: "healthcare",
      label: "Healthcare & Life Sciences",
      activeIcon: HSActive,
      inActiveIcon: HSInactive,
      points: [
        "Secure cloud infrastructure for hospitals and research centers",
        "HIPAA- and GDPR-compliant CyberSecurity frameworks",
        "AI analytics for patient insights and drug discovery",
        "Telehealth and remote monitoring platforms",
      ],
      image: HealthCareLifeSciences,
    },
    {
      key: "logistics",
      label: "Logistics & Supply Chain",
      activeIcon: LSactive,
      inActiveIcon: LSInactive,
      points: [
        "End-to-end supply chain visibility platforms",
        "AI-powered demand forecasting & route optimization",
        "Automation for freight, invoicing, and tracking",
        "Cloud & IoT-based logistics management systems",
      ],
      image: LogisticsSupplyChain,
    },
  ];

  const activeContent = tabs.find((t) => t.key === activeTab);
  const navTo = (type) => {
    if (type === "retail") {
      navigate("/Industries/RWG");
    } else if (type === "government") {
      navigate("/Industries/GPS");
    } else if (type === "healthcare") {
      navigate("/Industries/HLS");
    } else if (type === "logistics") {
      navigate("/Industries/LSC");
    }
  };
  console.log("caseStudiesData", caseStudiesData);
  const caseStudyDetails = (content) => {
    navigate("/CaseStudies/Details", { state: { data: content } });
  };

  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[630px]">
          <img
            src={CS_BG}
            alt="About Banner"
            className="absolute inset-0 h-full w-full "
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0 mx-auto left-0 right-0">
            <div className="max-w-2xl font-roboto space-y-4">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569] font-bold text-xl">
                  CASE STUDIES
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Real Results, Real Impact
              </h1>
              <div className="max-w-lg font-roboto space-y-4">
                <p className="text-lg text-[#404040]">
                  At TechProjects, we don’t just deliver services — we create
                  measurable outcomes. Explore how we’ve helped clients across
                  industries with AI, CyberSecurity, digital transformation, and
                  global delivery models.
                </p>
              </div>
            </div>
          </div>
        </div>
        <section className="bg-white py-16 px-3 font-roboto px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto mb-16 space-y-8">
            <div className="grid gap-2 items-center mb-2">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-4xl md:text-7xl font-extrabold text-[#434253]">
                Featured Case Studies
              </h2>
            </div>
            <p className="text-[#404040] text-sm md:text-lg mt-1 font-400">
              We empower businesses with AI-driven tools and automation that
              optimize operations, enhance customer experiences, and unlock
              measurable value across the supply chain:
            </p>
          </div>

          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto flex flex-col gap-12">
            {caseStudiesData.map((caseStudy, index) => {
              const isReverse = index % 2 !== 0;
              return (
                <div
                  key={index}
                  className={`flex flex-col md:${
                    isReverse ? "flex-row-reverse" : "flex-row"
                  } justify-between items-center md:items-start md:gap-10`}
                >
                  {/* CONTENT */}
                  <div className="flex-1">
                    <h3 className="text-[32px] font-semibold text-[#5F6870] mb-3">
                      {caseStudy.title}
                    </h3>
                    <div
                      className="
                          mb-14 ml-6 text-xl text-[#0F172A]
                          [&>ul]:list-disc
                          [&>ul]:space-y-6
                          font-500 
                        "
                      dangerouslySetInnerHTML={{
                        __html: caseStudy.shortDescription,
                      }}
                    />

                    <a
                      onClick={() => caseStudyDetails(caseStudy)}
                      className="text-[#F42F39] font-500 text-xl inline-flex items-center cursor-pointer hover:underline"
                    >
                      Read Full Story
                      <i className="fa fa-arrow-right text-xs ml-2 mt-1"></i>
                    </a>
                  </div>
                  <div className="flex mt-6 md:mt-0">
                    <img
                      src={`${caseStudy.bannerImage}`}
                      alt={caseStudy.title}
                      className="w-[420px] object-contain"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </section>
        <section
          className="text-white flex items-center py-8 md:py-[6rem] relative overflow-hidden bg-cover bg-no-repeat"
          style={{ backgroundImage: `url(${BlueLarge})` }}
        >
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto text-center px-3 md:px-6">
            <span className="flex items-center justify-center font-bold text-lg tracking-wider space-x-2 mb-4">
              <span className="w-5 h-1.5 bg-activeColor"></span>
              <span className="w-9 h-1.5 bg-activeColor"></span>
            </span>
            <h2 className="text-3xl md:text-4xl xl:text-[56px] font-extrabold text-white leading-tight md:mb-[6rem]">
              Impact in Numbers
            </h2>
            <div className="flex flex-wrap justify-between gap-6 md:gap-12 mt-10 md:mt-16">
              {[
                {
                  value: "40%",
                  label: "Faster Incident Response (Government)",
                },
                { value: "23%", label: "Better Inventory Turnover (Retail)" },
                {
                  value: "85%",
                  label: "Automated Claims Processing (Finance)",
                },
                {
                  value: "30%",
                  label: "Cost savings With GCC Setups (Logistics/Enterprise)",
                },
              ].map((item, index) => (
                <div key={index} className="text-center flex-1 min-w-[120px]">
                  <p className="text-3xl md:text-4xl font-bold">{item.value}</p>
                  <p className="text-md tracking-wider font-normal opacity-90">
                    {item.label}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="bg-white py-16 px-6 md:px-12 font-roboto">
          <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto">
            <div className="mb-14">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2 mb-3">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
              </span>
              <h2 className="text-3xl md:text-7xl font-extrabold text-[#434253] max-w-xl mb-4">
                Case Studies by Industry
              </h2>
              <p className="text-[#404040] font-400 text-xl max-w-4xl">
                At TechProjects, we go beyond technology support — we design
                solutions that build, automate, and transform businesses.
              </p>
            </div>

            <div className="flex flex-wrap gap-4 mb-10">
              {tabs.map((tab, id) => (
                <button
                  key={tab?.key}
                  onClick={() => setActiveTab(tab?.key)}
                  className={`flex items-center gap-2 px-4 py-4 text-[22px] rounded-lg font-500 transition-all ${
                    activeTab === tab?.key
                      ? "bg-activeColor text-white"
                      : "text-[#404040] hover:bg-gray-200"
                  }`}
                >
                  <img
                    src={
                      activeTab === tab?.key
                        ? tab?.activeIcon
                        : tab?.inActiveIcon
                    }
                    alt={tab?.key}
                    className="object-contain"
                  />
                  {tab?.label}
                </button>
              ))}
            </div>

            <div className="grid md:grid-cols-2 gap-8 items-start">
              <div className="grid items-center h-full">
                <ul className="list-disc text-[#5F6870] font-400 text-lg space-y-6 ml-8 mb-6">
                  {activeContent.points.map((point, i) => (
                    <li key={i}>{point}</li>
                  ))}
                </ul>
                {/* <a
                onClick={() => navTo(activeTab)}
                className="text-[#F42F39] font-500 text-xl inline-flex items-end hover:underline cursor-pointer"
              >
                Read Full Story
                <i className="fa fa-arrow-right text-xs ml-2 mb-1"></i>
              </a> */}
              </div>

              <div className="m-auto">
                <img
                  src={activeContent.image}
                  alt={activeContent.label}
                  className="object-contain w-[420px] h-[320px]"
                />
              </div>
            </div>
          </div>
        </section>
        <div
          className="w-full bg-cover bg-no-repeat p-[5rem]"
          style={{ backgroundImage: `url(${BlueCard})` }}
        >
          <div className="grid items-center justify-center h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-4 md:px-6">
            <div className="font-roboto text-4xl md:text-7xl text-center text-white font-medium max-w-6xl grid space-y-6">
              <span>Your Success Could Be Next</span>
              <span className="text-white text-lg font-400">
                Let’s work together to solve your toughest challenges and create
                measurable impact.
              </span>
            </div>

            <div className="w-full md:max-w-6xl mx-auto gap-6 flex md:justify-center justify-center mt-10">
              <button
                type="submit"
                className="bg-activeColor text-white text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium hover:bg-red-600 transition-all flex items-center gap-4"
              >
                Start Your Project
              </button>
              <button
                onClick={handleClick}
                type="submit"
                className=" text-white border-white border text-lg md:text-2xl px-5 md:px-6 py-2 md:py-3 rounded-md font-medium transition-all flex items-center gap-4"
              >
                Contact Us
              </button>
            </div>
          </div>
        </div>
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default CaseStudies;
